module.exports = __webpack_public_path__ + "static/media/switch.2be41fd5.svg";